import { Component, _decorator } from 'cc';

const { ccclass } = _decorator;

@ccclass('DropdownOption')
export default abstract class DropdownOption extends Component {
    public abstract onSelected(): void;
    public abstract onDeselected(): void;
}
